import { organisationConstants } from '../../../_constants';

const initialState = { getAttributeLoading: true, data: '', error: false };

export function ManageAttributeList(state = initialState, action) {
    switch (action.type) {
        case organisationConstants.REQUEST_ATTRIBUTE_LIST:
            return {
                getAttributeLoading: true,
                data: '',
                error: false
            };
        case organisationConstants.RECIEVE_ATTRIBUTE_LIST:
            return {
                getAttributeLoading: false,
                data: action.attributeList,
                error: false
            };
        case organisationConstants.ERROR_ATTRIBUTE_LIST:
            return {
                getAttributeLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/manageMetric/getAttributeList.reducer.js